import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Heading from "@components/layout/Heading";
import Breadcrumb from "@components/layout/Breadcrumb";
import Loading from "@components/shared/Loading";
import TabPanels from "@components/form/TabPanels";
import WaterEntitlements from "./WaterEntitlements";
import ZoneAccountSummary from "./ZoneAccountSummary";
import OfftakesAndMetersTab from "./OfftakesAndMetersTab";
import TransactionHistory from "./TransactionHistory";
import { useGetZoneAccountById } from "@hooks/query/useGetZoneAccountById";
import { useAppContext } from "@context/AppContext";

export default function ZoneAccount() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { checkPermissions } = useAppContext();
  const { data, isLoading } = useGetZoneAccountById(id ?? "");

  const breadcrumb = [
    {
      label: "Dashboard",
      href: "/zenith",
    },
    {
      label: `${t("zenith.zone_accounts.title")} ${data?.identifier}`,
    },
  ];

  return (
    <>
      <Breadcrumb items={breadcrumb} />
      <header className="mt-3">
        <Heading>
          {t("zenith.zone_accounts.title")} {data?.identifier}
        </Heading>

        {isLoading ? (
          <div className="pt-8">
            <Loading />
          </div>
        ) : (
          <section className="mt-5">
            <div className="bg-white border border-gray-300">
              <TabPanels
                tabs={[
                  {
                    title: t("zenith.zone_accounts.tabs.summary"),
                    panel: <ZoneAccountSummary />,
                  },
                  {
                    title: t("zenith.zone_accounts.tabs.water_entitlements"),
                    panel: <WaterEntitlements />,
                  },
                  {
                    title: t("zenith.zone_accounts.tabs.offtakes_and_meters"),
                    panel: <OfftakesAndMetersTab />,
                  },
                  ...(checkPermissions(["ViewEventTransactions"])
                    ? [
                        {
                          title: t(
                            "zenith.zone_accounts.tabs.transaction_history",
                          ),
                          panel: <TransactionHistory />,
                        },
                      ]
                    : []),
                ]}
              />
            </div>
          </section>
        )}
      </header>
    </>
  );
}
